//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'RSBI',
  data () {
    return {
      defaultJson: {
        'Respiratory Rate': '呼吸频率',
        'RSBI': 'RSBI',
        'Successful weaning predicted': '预测脱机成功',
        'Tidal Volume': '潮气量',
        'Weaning failure predicted': '预测脱机失败'
      },
      form: {
        rr: '',
        vt: ''
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        {value: '0', name: '从不'},
        {value: '10', name: '一周内'},
        {value: '5', name: '曾有'}
      ],
      dataList2: [
        {value: '0', name: '从不'},
        {value: '10', name: '6个月内'},
        {value: '5', name: '超过6个月'}
      ],
      logit: '...'
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      console.log(self.form)
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key] && key !== 'drop') {
            flag = false
          } else {
            if (form[key] === '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }

      if (!flag) {
        self.hasScore = false
        self.logit = '...'
        return '...'
      } else {
        console.log(form)
        let result = 0
        result = form.rr / form.vt
        self.hasScore = true
        if (result <= 105) {
          self.logit = self.defaultJson['Successful weaning predicted']
        } else {
          self.logit = self.defaultJson['Weaning failure predicted']
        }

        return String(result)
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/formulas/Anae/RSBI.vue